import { render, staticRenderFns } from "./cfdeEcoSystem.vue?vue&type=template&id=0b580dfc"
import script from "./cfdeEcoSystem.vue?vue&type=script&lang=js"
export * from "./cfdeEcoSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b580dfc')) {
      api.createRecord('0b580dfc', component.options)
    } else {
      api.reload('0b580dfc', component.options)
    }
    module.hot.accept("./cfdeEcoSystem.vue?vue&type=template&id=0b580dfc", function () {
      api.rerender('0b580dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeEcoSystem.vue"
export default component.exports